export enum Status {
  OK = 'OK',
  WARNING = 'WARNING',
}
